// 要素がビューポートに入ったら一度だけコールバックを実行するヘルパー。
// IntersectionObserver 非対応環境では即時実行する（要素が隠れたままにならないように）。
export function onEnterView(el, callback, threshold = 0.1) {
  if (!('IntersectionObserver' in window)) {
    callback();
    return;
  }
  const io = new IntersectionObserver((entries, observer) => {
    if (entries.some((e) => e.isIntersecting)) {
      observer.disconnect();
      callback();
    }
  }, { threshold });
  io.observe(el);
}
